import { useState as s, useEffect as u } from "react";
const l = (e) => {
  const [r, o] = s(null), [c, n] = s(null);
  return u(() => {
    if (!e) {
      const t = typeof document < "u" ? document.body : null;
      o(t), n((t == null ? void 0 : t.getBoundingClientRect()) || null);
      return;
    }
    try {
      if (!document.body.contains(e)) {
        console.warn("DrawerTemplate: Provided container is not in the DOM"), o(document.body), n(document.body.getBoundingClientRect());
        return;
      }
      window.getComputedStyle(e).position === "static" && console.warn(
        "DrawerTemplate: Container has static positioning, which may cause positioning issues"
      ), o(e), n(e.getBoundingClientRect());
      const i = new ResizeObserver(() => {
        n(e.getBoundingClientRect());
      });
      return i.observe(e), () => {
        i.disconnect();
      };
    } catch (t) {
      console.error("DrawerTemplate: Error setting container", t), o(document.body), n(document.body.getBoundingClientRect());
    }
  }, [e]), {
    portalContainer: r,
    containerRect: c,
    isCustomContainer: !!e && r === e
  };
};
export {
  l as useDrawerPortalContainer
};
//# sourceMappingURL=index.es5753.js.map
